// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3_fT1","ranges":"BmiRanges_ranges__18gij"};